import React from "react";
import Icon from "components/AppIcon";
import { useNavigate } from "react-router-dom";

const portfolioData = {
  totalValue: "$48,320.75",
  invested: "$42,100.00",
  todayGain: "+$384.22",
  todayGainPct: "+0.80%",
  overallROI: "+14.77%",
  overallGain: "+$6,220.75",
  isUp: true,
  holdings: [
    { ticker: "AAPL", shares: 15, value: "$3,421.50", change: "+2.14%", up: true },
    { ticker: "MSFT", shares: 8, value: "$2,987.20", change: "+0.92%", up: true },
    { ticker: "NVDA", shares: 5, value: "$4,102.50", change: "+4.82%", up: true },
    { ticker: "TSLA", shares: 10, value: "$1,876.30", change: "-3.21%", up: false },
  ],
};

export default function PortfolioSummary() {
  const navigate = useNavigate();

  return (
    <section
      className="rounded-xl p-4 md:p-5"
      style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
      aria-label="Portfolio Summary"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl" style={{ color: "var(--color-foreground)" }}>
          My Portfolio
        </h2>
        <button
          onClick={() => navigate("/portfolio-tracker")}
          className="font-caption text-xs font-medium flex items-center gap-1 transition-colors"
          style={{ color: "var(--color-accent)" }}
        >
          View All <Icon name="ChevronRight" size={14} color="var(--color-accent)" />
        </button>
      </div>
      {/* Total Value */}
      <div className="mb-4">
        <p className="font-caption text-xs mb-1" style={{ color: "var(--color-muted-foreground)" }}>
          Total Portfolio Value
        </p>
        <p
          className="font-data font-bold text-2xl md:text-3xl"
          style={{ color: "var(--color-accent)" }}
        >
          {portfolioData?.totalValue}
        </p>
        <div className="flex items-center gap-3 mt-1 flex-wrap">
          <div className="flex items-center gap-1">
            <Icon
              name={portfolioData?.isUp ? "TrendingUp" : "TrendingDown"}
              size={14}
              color={portfolioData?.isUp ? "#059669" : "#DC2626"}
            />
            <span
              className="font-data text-sm font-semibold"
              style={{ color: portfolioData?.isUp ? "#059669" : "#DC2626" }}
            >
              {portfolioData?.todayGain} ({portfolioData?.todayGainPct}) today
            </span>
          </div>
          <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
            Overall: <span className="font-semibold" style={{ color: "#059669" }}>{portfolioData?.overallROI}</span>
          </span>
        </div>
      </div>
      {/* Stats Row */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div
          className="rounded-lg p-3"
          style={{ background: "var(--color-muted)" }}
        >
          <p className="font-caption text-xs mb-1" style={{ color: "var(--color-muted-foreground)" }}>
            Invested
          </p>
          <p className="font-data font-semibold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
            {portfolioData?.invested}
          </p>
        </div>
        <div
          className="rounded-lg p-3"
          style={{ background: "var(--color-muted)" }}
        >
          <p className="font-caption text-xs mb-1" style={{ color: "var(--color-muted-foreground)" }}>
            Total Gain
          </p>
          <p className="font-data font-semibold text-sm md:text-base" style={{ color: "#059669" }}>
            {portfolioData?.overallGain}
          </p>
        </div>
      </div>
      {/* Top Holdings */}
      <div>
        <p className="font-caption text-xs font-semibold mb-2" style={{ color: "var(--color-muted-foreground)" }}>
          TOP HOLDINGS
        </p>
        <div className="space-y-2">
          {portfolioData?.holdings?.map((h) => (
            <div key={h?.ticker} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span
                  className="font-data text-xs font-semibold px-2 py-0.5 rounded"
                  style={{ background: "rgba(0,48,87,0.08)", color: "var(--color-primary)" }}
                >
                  {h?.ticker}
                </span>
                <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                  {h?.shares} shares
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-data text-xs font-medium" style={{ color: "var(--color-foreground)" }}>
                  {h?.value}
                </span>
                <span
                  className="font-data text-xs font-semibold"
                  style={{ color: h?.up ? "#059669" : "#DC2626" }}
                >
                  {h?.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}